var commitDate = '2019110311';
var HistoryManager = {
	init : function(  fncGetParam, fncLoadAjax ) {
		var _this = this;
		_this.fncGetParam = fncGetParam; 
		_this.fncLoadAjax = fncLoadAjax;	
		
		function locationHashChanged() {
			var backspaced = false;
			if( document.location.hash ){
				backspaced = ( _this.eh != document.location.hash.substring(1) );
			} else {
				backspaced = true;
				_this.eh = undefined;
			}
			_this.loadAjax(backspaced);
		}
						
		function stateChanged() {
		    var gbn = $('#filter-category').data('gbn');

		    if(gbn == 'D'){
                var currentUrl = document.location.href;
                if(currentUrl.indexOf("grand") > -1 || currentUrl.indexOf("signature") > -1){
                    var params = {};
                    window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(str, key, value) {
                        params[key] = value;
                    });

                    $('#filter-category').attr('data-category', params.sectId);
                    _this.changeHash()
                }
            }

            if( history.state && history.state.eh ){

			    var internal = (_this.eh == history.state.eh);
			    if (!internal) {
			    	_this.eh = history.state.eh;
			        _this.loadAjax(true);
			    } else {
			    	//history.back();
			    }
			} else if( _this.eh ){
		    	_this.eh = null;
		        _this.loadAjax(true);
			}
		}

		if(typeof history.state != 'undefined' ){
			//history.pushState({ eh: "" }, document.title, window.location.href); -
			window.addEventListener("popstate", stateChanged, false);
		} else {
			window.onhashchange = locationHashChanged;
		}
	},
	changeHash:function(){
		var _this = this;

		var params = _this.fncGetParam();

		var sectId = $('#filter-category').attr('data-category');

		if (sectId) {
			_this.sectId = sectId;
		}

		var hash = _this.makeHash(params);
		_this.eh = hash;

		if(typeof history.state != 'undefined' ){
			_this.loadAjax();
		} else {
			if( hash ){
				document.location.hash = "#" + hash;
			} else {
				document.location.hash = "";
			}
		}

	},
	makeHash:function(params){
		var _this = this;

		var hash = undefined;
		if( ! $.isEmptyObject( params ) ){
			_this.dataLayerParams = params;
			hash = encodeURIComponent( Base64.encode( JSON.stringify(params) ) );
		}

		return hash;
	},
	getHashParam:function(){
		var _this = this;

		var result = "";
		if( typeof history.state != 'undefined' ){
			if( _this.eh ){
				result += "&eh="+_this.eh;
			}
		} else {
			if( document.location.hash ){
				result += "&eh="+document.location.hash.substring(1);
			}
		}

		return result;
	},
	loadAjax:function(forceRender){
		var _this = this;
		var jbpGbn = $('#filter-sort').attr('jbp-gbn');
		_this.fncLoadAjax( forceRender, function( returnUrl ){
			
			if (!forceRender && typeof history.state != 'undefined') {
				if( !history.state || history.state && _this.eh != history.state.eh ){
					if (jbpGbn == 'NEW') {
						history.pushState({ eh: _this.eh , cornNo: _this.sectId}, document.title,  returnUrl);        				
					} else {
						history.pushState({ eh: _this.eh , sectId: _this.sectId}, document.title,  returnUrl);        				
					}
				}
			}
			
		});		
	}
};